<div class="modal-header bg-dark">
  <h4 class="modal-title" translate>Hochladen bestätigen</h4>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="modal.dismiss()"></button>
</div>
<div class="modal-body multiline" translate>ConfirmUploadMessagePart1</div>
<div class="modal-body multiline" translate>ConfirmUploadMessagePart2</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="modal.close()" translate>Hochladen</button>
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="modal.dismiss()"
    appAutofocus
    translate>
    Abbrechen
  </button>
</div>
